// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1OdAl","list":"BalanceDue_list__171G4","listRow":"BalanceDue_listRow__3h4E3","total":"BalanceDue_total__3aB8P"};